// import { register } from '../../module/Register/locale/register.en.js';
// base
import { date } from '@/helper/locale/base/base_date.en.js';
import { button } from '@/helper/locale/base/base_button.en.js';
// module
import { collect_point } from '@/module/CollectPoint/locale/collectpoint.en.js';
import { home } from '@/module/Home/locale/home.en.js';
import { register } from '@/module/Register/locale/register.en.js';
import { profile } from '@/module/Profile/locale/profile.en.js';
import { transfer } from '@/module/TransferPoint/locale/transfer.en.js';
import { contactus } from '@/module/ContactUs/locale/contactUs.en.js';
import { forgetpassword } from '@/module/ForgetPassword/locale/forgetpassword.en.js';
import { TransferMAAI } from '@/module/TransferMAAI/locale/TransferMAAI.en.js';

export const en = {
    // base
    date,
    button,
    // module
    collect_point,

    home: home,
    profile: profile,
    register: register,
    transfer,
    contactus,
    forgetpassword,
    TransferMAAI: TransferMAAI,

    commonLbl:{
        profile: 'profile',
        logout: 'logout',
    },
    otp: {
        headline: 'Verify OTP',
        contact_number_lbl: 'OTP Sent to',
        refcode_lbl: 'Ref code: ',
        timeleft: 'Time Remaining : ',
        resend_otp: 'Resend OTP',
        ok_btn: 'Confirm',
        cancel_btn: 'Cancel',
        otp_incorrect: "You enter incorrect OTP, please try again.",
        confirm: "Confirm"
    },

    confirm_redeem: {
        confirm: "Confirm",
        cancel: "Cancel",

        headline: 'Confirm',
        headline2: 'Redeem Confirmation',
        default_text: 'Do you wish to use',
        to_redeem: 'to redeem',
        this_reward: 'this reward?',
        default: 'Confirm to redeem',
        defualt_have_time: 'Serial will available for {0} after confirm',
        delivery: 'Please enter shipping information to redeem',
        free: 'Serial will available for {0} after confirm',
        free_no_timer: 'Confirm to redeem',
        free_delivery: 'Please enter shipping information to redeem',
        draw: 'Confirm to join campaign <br/> Winner will be announced after {0}',
        draw_delivery: 'Please enter shipping information to redeem',
        deal: 'Serial will available for {0} after confirm',
        deal_no_timer: 'Confirm to redeem',
        deal_delivery: 'Please enter shipping information to redeem',
        buy: 'Confirm to purchase',
        buy_delivery: 'Please enter shipping information to buy',
        interface: 'This will redirect to website after confirm',
    },
    redeem_button: {
        default: 'Redeem',
        none: '',
        soldOut: 'Sorry, This reward is reaching redemption limit.',
        soldOutBuy: 'Sorry, This reward is reaching redemption limit.',
        maxPerPerson: 'Sorry, You have already redeemed this reward.',
        redeemCoolDown: 'This campaign has been used for this period.',
        nextDate: '<br/>at : ',
        exceedBuyPointLimitPerday: '',
        conditionIsInvalid: 'This campaign requires user action before redemption, please review the conditions first.',
        campaignExpired: 'Campaign has expired.',
        campaignExpiredBuy: 'Campaign has expired.',
        campaignNotAvailable: 'Sorry. This reward is not available',
        campaignNotAvailableBuy: 'Sorry. This product is not available',
        notEnoughPoint: 'Sorry, your point is not enough.',//'Your point are not enough to redeem this campaign.',
        notSupport: 'This campaign is not support.',
        notMAAIMember: 'Not a MAAI member',
    },
    purchase: {
        show_code: 'view code',
        code_expired: 'This serial has expired.',

        delivery: 'Product will be mailed based on Campaign Condition.',
        shipped: 'The Product has been delivered.',
        parcel_no: 'ParcelNo',

        not_draw1: 'Not yet drawn,',
        not_draw2: 'please check back at a later date',
        draw_winner1: 'You are the winner',
        draw_winner2: '',
        draw_not_win1: 'Sorry you are not the winner,',
        draw_not_win2: 'better luck next',
        parcelNo: 'Parcel no',
        status: 'Status',
        privilege_shipped_fail: 'Fail delivered',
        privilege_shipped: 'Delivered',
        privilege_delivery: 'In Process',
        privilege_prepare: 'Preparing',
    },
    serial: {
        close_btn: 'Close',
        default_privilege_message: 'As design',
        show_code_at_shop: 'Please show code below to claim your privilege',
        show_code: 'Present the code received to the staff',

        delivery: 'Product will be mailed based on Campaign Condition.',

        draw: 'Thank you for joining us.<br/>Winner will be announced after {0}',
        draw_after: 'after',

        qr_code: 'QR Code',
        barcode: 'Barcode',
        code: 'Code',

        copy_code: 'Copy Code',

        expire_in: 'The code will be expired in : ',
        code_expired: 'This serial has expired.',

        redeem_on: 'Redeem on {0}',
        use_on: 'Redeem Date : ',

        slide_to_unmask: 'Slide to mask used',
        Used: "Used",
        copy: 'Copy',
        isUsed: 'Already in use',
        isExpired: 'Expired',
    },
    shipping: {
        headline: 'Shipping address',
        title: 'Delivery Address',
        firstname: {
            name: 'Firstname',
            placeholder: 'Firstname',
            required: 'Please enter firstname',
            too_short: '',
            invalid: '',
        },
        lastname: {
            name: 'Lastname',
            placeholder: 'Lastname',
            required: 'Please enter lastname',
            too_short: '',
            invalid: '',
        },
        addressName: {
            name: 'Address name',
            placeholder: 'Address name',
            required: 'Please enter address name',
            too_short: '',
            invalid: '',
        },
        address:  {
            name: 'Address',
            placeholder: 'Address',
            required: 'Please enter address',
            too_short: '',
            invalid: '',
        },
        contactnumber: {
            name: 'Contact number',
            placeholder: 'Contact number',
            required: 'Contact number',
            too_short: 'Contact number must be {0} digits',
            invalid: 'Incorrect contact number format',
        },
        nationalid: {
            name: 'National id',
            placeholder: 'National id',
            required: 'Please enter national id',
            too_short: 'National id number must be {0} digits',
            invalid: 'Incorrect national id format',
        },
        email: {
            name: 'Email',
            placeholder: 'Email',
            required: 'Please enter email address',
            too_short: '',
            invalid: 'Incorrect email format',
        },
        zipcode: {
            name: 'Postcode',
            placeholder: 'Postcode',
            required: 'Please enter postcode',
            too_short: 'Postcode must be {0} digits',
            invalid: 'Invalid postcode',
        },
        subdistrict: {
            name: 'Sub district',
            placeholder: 'Please selece sub-district',
            required: 'Please selece sub-district',
            too_short: '',
            invalid: '',
        },
        district: {
            name: 'District',
            placeholder: 'Please selece district',
            required: 'Please selece district',
            too_short: '',
            invalid: '',
        },
        province: {
            name: 'Province',
            placeholder: 'Please selece province',
            required: 'Please selece province',
            too_short: '',
            invalid: '',
        },

        isDefaultAddress: 'Is default address.',
        defaultAddress: 'Default',
        save_address: 'Save address for next privilege',
        save_address_buy: 'Save address for next puchase',

        confirm_btn: 'Confirm',
        cancel_btn: 'Cancel',

        alert_headline: 'Shipping address',
        alert_ok_btn: 'OK',
    },
    tax: {
        personType: {
            name: 'ออกในนาม',
            placeholder: '',
            required: 'กรุณาเลือก',
            too_short: '',
            invalid: '',
        },
        title: {
            name: 'คำนำหน้าชื่อ',
            placeholder: '',
            required: 'กรุณาเลือก',
            too_short: '',
            invalid: '',
        },
        companyName: {
            name: 'ชื่อ / บริษัท',
            placeholder: 'ชื่อ / บริษัท',
            required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
            too_short: '',
            invalid: '',
        },
        building: {
            name: 'อาคาร',
            placeholder: 'อาคาร',
            required: '',
            too_short: '',
            invalid: '',
        },
        room: {
            name: 'เลขที่ห้อง',
            placeholder: 'เลขที่ห้อง',
            required: '',
            too_short: '',
            invalid: '',
        },
        floor: {
            name: 'ชั้นที่',
            placeholder: 'ชั้นที่',
            required: '',
            too_short: '',
            invalid: '',
        },
        village: {
            name: 'หมู่บ้าน',
            placeholder: 'หมู่บ้าน',
            required: '',
            too_short: '',
            invalid: '',
        },
        number: {
            name: 'เลขที่',
            placeholder: 'เลขที่',
            required: '',
            too_short: '',
            invalid: '',
        },
        moo: {
            name: 'หมู่ที่',
            placeholder: 'หมู่ที่',
            required: '',
            too_short: '',
            invalid: '',
        },
        soi: {
            name: 'ซอย',
            placeholder: 'ซอย',
            required: '',
            too_short: '',
            invalid: '',
        },
        road: {
            name: 'ถนน',
            placeholder: 'ถนน',
            required: '',
            too_short: '',
            invalid: '',
        },
    },
    main: {
        home_page: "Home",
        login: "Login",
        campaign: "Campaign",
        category: 'Category',
        map: "Map",
        terms: "Terms And Conditions",
        history: 'History',
        profile: "Profile",
        logout: "Logout",
        lang: "Language",
        msgLogout: "Logout ?",
        cancel: "Cancel",
    },
    campaign: {
        point: 'Point',
        get_point: 'Get Point : ',
        use_point: 'Use Point : ',
        get: 'get',
        use: 'use',
    },
    detail: {
        detail: 'Details',
        condition: 'Conditions',

        point_unit: 'Point',
        get_point: 'Get Point : ',
        use_point: 'Use ',
        available_date: 'Date',
        expire_date: 'Expire date : {0}',

        color: {
            name: 'Color',
            placeholder: 'Please select color',
            required: 'Please select color',
        },
        size: {
            name: 'Size',
            placeholder: 'Please select size',
            required: 'Please select size',
        },
        success_modal: {
            title: 'Succesfully redeem  <br> and fill-in Delivery Address',
            redeem_date: 'Redeem Date : ',
            my_reward: 'My Privileges',
            more_reward: 'Redeem additional privileges'
        }
    },
    history: {
        title: 'Coins History',
        point: 'Point',
        get_point: 'Get Point : ',
        use_point: 'Use Point : ',
        earn_tab: 'Coins Earn',
        burn_tab: 'Coins Burn',
        tranfer_tab: 'Transfer',
        expire: 'Expired',
        show_code: 'Click to show code',
        earn_coin_from: "ได้รับการโอน Coin จากหมายเลข",
        transfer_coin_from: "โอน Coin ไปยังหมายเลข",
        nodata: 'ไม่มีข้อมูล',

        parcel_number: 'Parcel No. : ',
        datePicker: {
            name: 'วันที่',
            placeholder: 'วันที่',
            required: '',
            too_short: '',
            invalid: '',
            date: {
                name: '',
                placeholder: 'Day',
                required: ' '
            },
            month: {
                name: '',
                placeholder: 'Month',
                required: ' '
            },
            year: {
                name: '',
                placeholder: 'Year',
                required: ' '
            },
        },
    },
    day: {
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun',
    },
    terms: {
        accept: 'Accept',
        not_accept: 'Not Accept',
    },
    login: {
        register_login: 'Register/Login',
    },
    bottom_bar: {
        home: 'Home',
        reward: 'Reward',
        mission: 'Mission',
        profile: 'Profile',
    },
    topbar: {
        coin: 'Coins',
        call_center: 'Call Center',
    },
    getfriend: {
        title: "Event detail",
        register_done: 'Successfully invited ',
        person: 'person',
        fill_mobile: 'Fill-in your friends Mobile Number',
        invitations: 'You can send 10 invitations per session',
        contact_number: 'Contact Number',
        enter_contact: 'Fill-in contact number',
        more_input: 'Add more field',
        confirm_sms: 'Send Invitation',
        invite_success: 'Invite Success',
        congratulation: 'Congratulation',
        invite_full: 'You have invited 10 persons',

        invite_friend: 'INVITE FRIENDS',
        checkin_success: 'Checkin success',
        event_description: 'Event detail',
        invite_friend_sms: 'Send invitation via SMS',
        friend_get_friend: 'Friend Get Friend',
        invite_detail: 'Get extra coins from inviting your friend to joinรing, Maximum 10 invitations',
        checkin: 'Check in',
        checkedin: 'Checked in'

    }

};
